const BlackListDevices = () => import(/* webpackChunkName 'BlackListDevices' */ '@/components/BlackListDevice/BlackListDevicesList/BlackListDevicesList.vue');

export default {
    path: 'blacklist-devices',
    name: 'blacklist_devices',
    meta: {
        label: 'BlackList Devices'
    },
    component: BlackListDevices,
    props: true
};